<script>
  import gql from 'graphql-tag'

  export default {
    props: ['gid'],
    apollo: {
      settings: {
        fetchPolicy: "no-cache",
        query: gql`query($gid: ID) {
          merchant(gid: $gid) { merchantUser { settings {
            warranty { supportPhone followUpAfterHours }
          }}}
        }`,
        variables() {
          return { gid: this.gid }
        },
        update: data => data.merchant.merchantUser.settings
      }
    },
    data() {
      return {
        settings: {},
        showForm: false,
        form: { supportPhone: null, followUpAfterHours: null }
      }
    },
    computed: {
      supportPhone() {
        return this.settings.warranty && this.settings.warranty.supportPhone
      },
      followUpAfterHours() {
        return this.settings.warranty && this.settings.warranty.followUpAfterHours
      }
    },
    methods: {
      openEdit() {
        const w = this.settings.warranty || {}
        this.form.supportPhone = w.supportPhone
        this.form.followUpAfterHours = w.followUpAfterHours
        this.showForm = true
        this.$nextTick(() => M.updateTextFields())
      },
      save() {
        this.$apollo.mutate({
          mutation: gql`mutation (
            $gid: ID!,
            $supportPhone: String,
            $followUpAfterHours: Int
          ) {
            updateWarrantyPreferences(input: {
              userId: $gid,
              supportPhone: $supportPhone,
              followUpAfterHours: $followUpAfterHours
            }) {
              warranty { supportPhone followUpAfterHours }
              errors
            }
          }`,
          variables: {
            gid: this.gid,
            supportPhone: this.form.supportPhone === '' ? null : this.form.supportPhone,
            followUpAfterHours: this.form.followUpAfterHours === '' ? null : this.form.followUpAfterHours
          }
        }).then(result => {
          const payload = result.data.updateWarrantyPreferences
          if (payload.errors && payload.errors.length) {
            this.notifyError(payload.errors.join(', '))
            return
          }
          this.settings = { ...this.settings, warranty: payload.warranty }
          this.showForm = false
          this.notifySuccess("Warranty preferences updated")
        }, error => {
          this.gqlErrorHandler(error)
        })
      }
    }
  }
</script>

<template>
  <div v-if="!$apollo.queries.settings.loading">
    <div class="very-close-lines">
      Warranty follow-up SMS:<br>
      <small class="grey-text">One text to customers who skipped the warranty offer</small>
    </div>

    <div v-if="settings.warranty" class="mt-5 grey-text">
      After:
      <template v-if="followUpAfterHours != null">{{ followUpAfterHours }} hour(s)</template>
      <template v-else>off</template>
      · Support phone:
      <template v-if="supportPhone">{{ supportPhone }}</template>
      <template v-else>profile phone</template>
      |
      <a class="pointer" @click="openEdit"><i class="far fa-edit"></i> Edit</a>
    </div>

    <div v-else class="mt-5 grey-text">
      Warranty not enabled
    </div>

    <div class="row mb-0 mt-10" v-show="showForm">
      <div class="input-field col s6">
        <input id="warranty_follow_up_after_hours" type="number" min="1" max="168" v-model.number="form.followUpAfterHours">
        <label for="warranty_follow_up_after_hours" class="active">Follow up after (hours)</label>
        <span class="helper-text grey-text">1–168; blank turns follow-ups off</span>
      </div>
      <div class="input-field col s6">
        <input id="warranty_support_phone" type="tel" v-model.trim="form.supportPhone">
        <label for="warranty_support_phone" class="active">Support phone</label>
        <span class="helper-text grey-text">Blank uses the profile phone</span>
      </div>
      <div class="col s12">
        <button class="btn-small emerald" @click="save" :disabled="$apollo.loading">Save</button>
        <a class="pointer ml-10 grey-text" @click="showForm = false">Cancel</a>
      </div>
    </div>
  </div>
</template>
